if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();

        this.quantity = this.querySelector('quantity-input');
        this.lastActiveInputId = null;
        this.localValue = null;
        this.isEnterPressed = false;

        const debouncedOnChange = debounce((event) => {
          const value = parseInt(event.target.value, 10) || 0;
          this.localValue = value;

          if (value === 0) {
            this.startQueue(event.target.dataset.index, value);
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.addEventListener('focusin', this.handleFocusIn.bind(this));
        this.addEventListener('keydown', this.handleKeyDown.bind(this));
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index, 10))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index, 10)))
          ) {
            return;
          }

          this.onCartUpdate();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      handleFocusIn(event) {
        if (event.target === this.input && !this.classList.contains('hidden')) {
          this.lastActiveInputId = event.target.id;
          event.target.select();
        }
      }

      handleKeyDown(event) {
        if (event.target !== this.input) return;

        this.lastActiveInputId = event.target.id;
        if (event.key === 'Enter') {
          this.input?.blur();
          this.isEnterPressed = true;
        }
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      restoreInputValue() {
        const input = this.input;
        if (!input || this.localValue === null) return;

        input.value = this.localValue;
        input.setAttribute('value', this.localValue);
      }

      onCartUpdate() {
        return fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
            if (sourceQty) {
              this.innerHTML = sourceQty.innerHTML;
              this.restoreInputValue();

              if (this.isEnterPressed && this.input) {
                this.input.select();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.isEnterPressed = false;
          });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const ownId = String(this.dataset.index);
        if (Object.prototype.hasOwnProperty.call(items, ownId)) {
          this.localValue = items[ownId];
        }

        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then((state) => {
            const parsedState = JSON.parse(state);

            const ownItem = parsedState.items?.find((item) => String(item.id) === ownId);
            if (ownItem) {
              this.localValue = ownItem.quantity;
            }

            this.renderSections(parsedState, ids);
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.selectProgressBar().classList.add('hidden');
            this.setRequestStarted(false);
            this.restoreInputValue();
          });
      }

      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (!sectionElement) return;

          if (section.section === 'cart-drawer') {
            sectionElement.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length === 0);
          }

          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;

          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        this.restoreInputValue();

        if (this.isEnterPressed && this.input) {
          this.input.select();
        }
      }
    }
  );
}